import React, { useState, useEffect } from 'react'
import { getClientByEmail, signInPortalAnon } from './portalApi'
import PortalLogin from './PortalLogin'
import PortalDashboard from './PortalDashboard'
import { font } from './portalStyles'
import { translations } from './portalI18n'

const ClientPortal = () => {
    const [client, setClient] = useState(null)
    const [loading, setLoading] = useState(true)
    const [lang, setLang] = useState(() => localStorage.getItem('portal_lang') || 'es')

    const handleSetLang = (l) => {
        localStorage.setItem('portal_lang', l)
        setLang(l)
    }

    const t = translations[lang]

    useEffect(() => {
        const style = document.createElement('style')
        style.textContent = 'html { scrollbar-width: none !important; } html::-webkit-scrollbar { display: none !important; }'
        document.head.appendChild(style)
        return () => style.remove()
    }, [])

    useEffect(() => {
        const savedEmail = localStorage.getItem('portal_email')
        if (!savedEmail) {
            setLoading(false)
            return
        }
        getClientByEmail(savedEmail)
            .then(async clientData => {
                if (clientData) {
                    await signInPortalAnon()
                    setClient(clientData)
                } else {
                    localStorage.removeItem('portal_email')
                }
            })
            .catch(() => localStorage.removeItem('portal_email'))
            .finally(() => setLoading(false))
    }, [])

    const handleLogin = async (clientData) => {
        localStorage.setItem('portal_email', clientData.mail || '')
        await signInPortalAnon()
        setClient(clientData)
    }

    if (loading) {
        return (
            <div style={{
                minHeight: '100vh', display: 'flex',
                alignItems: 'center', justifyContent: 'center',
                background: '#0f0f0f', fontFamily: font,
            }}>
                <div style={{ textAlign: 'center' }}>
                    <div style={{ fontSize: '32px', marginBottom: '12px', color: '#e8e8e8' }}>●</div>
                    <p style={{ color: '#888', fontSize: '14px' }}>{t.loadingPortal}</p>
                </div>
            </div>
        )
    }

    if (!client) {
        return <PortalLogin onLogin={handleLogin} lang={lang} setLang={handleSetLang} />
    }

    return <PortalDashboard client={client} lang={lang} setLang={handleSetLang} />
}

export default ClientPortal
